function parseEventDate(value: string | null | undefined): Date | null {
	if (!value || typeof value !== 'string') return null;
	const normalized = value.trim().replace(' ', 'T');
	const parsed = new Date(normalized);
	return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function startOfDay(date: Date): Date {
	const d = new Date(date);
	d.setHours(0, 0, 0, 0);
	return d;
}

function dayDiff(fromDate: Date, toDate: Date): number {
	const from = startOfDay(fromDate).getTime();
	const to = startOfDay(toDate).getTime();
	return Math.round((to - from) / (1000 * 60 * 60 * 24));
}

function getRelativeLabel(locale: string, diffDays: number): string | null {
	const lang = (locale || 'en').toLowerCase();
	if (diffDays === 0) {
		if (lang.startsWith('hr')) return 'Danas';
		if (lang.startsWith('sl')) return 'Danes';
		if (lang.startsWith('it')) return 'Oggi';
		if (lang.startsWith('de')) return 'Heute';
		return 'Today';
	}
	if (diffDays === 1) {
		if (lang.startsWith('hr')) return 'Sutra';
		if (lang.startsWith('sl')) return 'Jutri';
		if (lang.startsWith('it')) return 'Domani';
		if (lang.startsWith('de')) return 'Morgen';
		return 'Tomorrow';
	}
	return null;
}

export function formatEventDateFacebookStyle(value: string | null | undefined, locale: string): string {
	const eventDate = parseEventDate(value);
	if (!eventDate) return '';

	const now = new Date();
	const diffDays = dayDiff(now, eventDate);
	const relativeLabel = getRelativeLabel(locale, diffDays);

	const weekday = new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(eventDate);
	const datePart = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(eventDate);
	const hasSpecifiedTime = !(eventDate.getHours() === 0 && eventDate.getMinutes() === 0);
	const timePart = hasSpecifiedTime
		? new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(eventDate)
		: '';

	if (relativeLabel) {
		return timePart ? `${relativeLabel}, ${datePart}, ${timePart}` : `${relativeLabel}, ${datePart}`;
	}
	return timePart ? `${weekday}, ${datePart}, ${timePart}` : `${weekday}, ${datePart}`;
}
